let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bHGMG")).then(() => parcelRequire('3pTCH'));